const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97C6DB"
    },
    d: "M410.08,342.81l-12.93,90.79H68.37l-9.71-69.26c-1.08-7.76,3.21-15.28,10.45-18.29l29.18-12.11 v-29.02c0-8.55,6.26-15.8,14.72-17.03l6.9-1.01l11.59-39.19c2.16-7.32,8.88-12.33,16.5-12.33h118.55c4.51,0,8.64,1.74,11.72,4.6 c3.08,2.87,5.11,6.86,5.44,11.36l56.45,5.96c8.38,0.89,14.88,7.7,15.38,16.11l2.28,39.16l39.89,11.27 C406.01,326.16,411.29,334.28,410.08,342.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89BCCE"
    },
    d: "M392.48,395.48l-5.43,38.12H153.81l-3.26-23.29c-0.75-5.35,2.2-10.52,7.19-12.59l20.09-8.34V369.4 c0-5.88,4.31-10.88,10.13-11.73l4.76-0.69l7.97-26.98c1.49-5.04,6.11-8.49,11.36-8.49h81.61c3.11,0,5.95,1.2,8.07,3.17 c2.13,1.97,3.53,4.72,3.75,7.82l38.86,4.1c5.77,0.61,10.25,5.31,10.59,11.1l1.57,26.95l27.47,7.76 C389.68,384.02,393.31,389.61,392.48,395.48z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.824,
    y: 430.672,
    style: {
      fill: "#97C6DB"
    },
    width: 421.698,
    height: 5.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112B46"
    },
    d: "M100.793,382.875c-0.002,0.006-0.683,2.028-1.404,4.566c-0.72,2.543-1.483,5.579-1.645,7.703 l1.214,0.091c0.142-1.935,0.889-4.959,1.602-7.461c0.356-1.254,0.703-2.383,0.961-3.198c0.258-0.815,0.425-1.311,0.425-1.312 L100.793,382.875L100.793,382.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112B46"
    },
    d: "M89.912,383.878c0,0.001,0.024,0.205,0.061,0.579c0.11,1.12,0.331,3.728,0.331,6.562 c0,1.326-0.049,2.702-0.178,3.992l1.211,0.121c0.135-1.346,0.184-2.758,0.184-4.114c0-3.86-0.399-7.267-0.4-7.281 L89.912,383.878L89.912,383.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112B46"
    },
    d: "M83.879,391.929l0.005,0.005c0.041,0.046,0.292,0.34,0.521,0.756 c0.231,0.417,0.432,0.951,0.43,1.465h1.217c-0.003-0.872-0.331-1.619-0.64-2.157c-0.312-0.538-0.616-0.87-0.636-0.893 L83.879,391.929L83.879,391.929z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.1876,
    y1: 340.9726,
    x2: 115.1876,
    y2: 387.3046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7978E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563FDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M99.342,384.112c0,0-6.239-7.913,3.348-24.349c9.587-16.435,29.371-20.392,30.284-18.262 c0.913,2.131-10.044,6.239-13.088,18.87c-3.044,12.631-3.449,19.631-7.254,23.436 C108.828,387.612,103.654,389.134,99.342,384.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132076236234726668640000013397760695525801646_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.7478,
    y1: 370.4165,
    x2: 62.7478,
    y2: 393.4967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7978E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563FDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132076236234726668640000013397760695525801646_)"
    },
    d: "M86.498,385.706 c0,0-0.685-8.9-16.795-13.853c-16.11-4.953-31.374,4.343-30.69,6.279c0.684,1.936,10.288-1.963,19.852,4.439 c9.564,6.402,14.03,10.719,18.792,10.914C82.419,393.68,86.703,391.566,86.498,385.706z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023241363127541317550000016269097723312104368_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.0355,
    y1: 331.6843,
    x2: 77.0355,
    y2: 384.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7978E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563FDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023241363127541317550000016269097723312104368_)"
    },
    d: "M96.188,379.876 c0,0,10.747-11.539-1.715-30.004c-12.462-18.465-39.943-19.753-40.846-17.193c-0.903,2.559,10.755,7.389,15.28,21.911 c4.525,14.522,6.995,21.799,11.732,25.951C85.375,384.693,91.537,386.073,96.188,379.876z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M101.879,381.671c-0.054,0-0.109-0.007-0.163-0.023c-0.324-0.089-0.514-0.424-0.424-0.749 c0.279-1.005,6.962-24.722,19.322-33.781c0.27-0.2,0.651-0.141,0.851,0.131c0.199,0.271,0.14,0.652-0.131,0.851 c-12.018,8.808-18.801,32.882-18.868,33.125C102.39,381.494,102.146,381.671,101.879,381.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M89.432,378.665c-0.266,0-0.522-0.191-0.609-0.454c-0.034-0.103-0.039-0.167-0.072-0.66 c-0.557-8.343-4.11-36.016-26.441-41.858c-0.325-0.085-0.52-0.418-0.435-0.743c0.085-0.325,0.42-0.518,0.743-0.435 c23.118,6.048,26.777,34.408,27.347,42.956c0.015,0.229,0.024,0.378,0.033,0.439c0.106,0.319-0.076,0.622-0.395,0.729 C89.546,378.656,89.489,378.665,89.432,378.665z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M81.911,389.749c-0.276,0-0.548-0.246-1.437-1.051c-10.013-9.062-19.663-13.353-28.693-12.767 c-0.338,0.025-0.625-0.233-0.647-0.568c-0.022-0.335,0.232-0.624,0.568-0.647c9.374-0.623,19.323,3.788,29.589,13.079 c0.356,0.322,0.722,0.654,0.866,0.763c0.166,0.062,0.303,0.196,0.363,0.377c0.106,0.319-0.066,0.663-0.385,0.77 C82.054,389.733,81.983,389.749,81.911,389.749z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEE1F4"
    },
    d: "M106.82,430.983H75.43c-0.79,0-1.475-0.545-1.653-1.314l-8.218-35.513h51.132l-8.218,35.513 C108.295,430.439,107.61,430.983,106.82,430.983z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7AABBC"
    },
    points: "67.949,404.487 114.3,404.487 116.691,394.156 65.559,394.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BEE1F4"
    },
    points: "66.043,396.25 116.207,396.25 116.691,394.156 65.559,394.156  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.601,
    y: 104.085,
    style: {
      fill: "#0A2033"
    },
    width: 143.435,
    height: 78.092
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M230.949,108.309c0,0.836-0.678,1.514-1.514,1.514c-0.836,0-1.514-0.678-1.514-1.514 c0-0.836,0.678-1.514,1.514-1.514C230.271,106.795,230.949,107.473,230.949,108.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD15B"
    },
    d: "M237.271,108.309c0,0.836-0.678,1.514-1.514,1.514c-0.836,0-1.514-0.678-1.514-1.514 c0-0.836,0.678-1.514,1.514-1.514C236.593,106.795,237.271,107.473,237.271,108.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8578"
    },
    d: "M243.141,108.468c0,0.836-0.678,1.514-1.514,1.514c-0.836,0-1.514-0.678-1.514-1.514 c0-0.836,0.678-1.514,1.514-1.514C242.463,106.954,243.141,107.632,243.141,108.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.476,
    y: 120.022,
    style: {
      fill: "#FBD15B"
    },
    width: 78.916,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.141,
    y: 125.388,
    style: {
      fill: "#FBD15B"
    },
    width: 112.039,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.516,
    y: 130.754,
    style: {
      fill: "#FBD15B"
    },
    width: 86.539,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.785,
    y: 136.119,
    style: {
      fill: "#FBD15B"
    },
    width: 90.364,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.285,
    y: 141.485,
    style: {
      fill: "#FBD15B"
    },
    width: 61.04,
    height: 0.996
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.476,
    y: 169.322,
    style: {
      fill: "#FF8578"
    },
    width: 35.54,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.141,
    y: 163.956,
    style: {
      fill: "#FF8578"
    },
    width: 86.539,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.516,
    y: 158.591,
    style: {
      fill: "#FF8578"
    },
    width: 112.039,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.785,
    y: 153.225,
    style: {
      fill: "#FF8578"
    },
    width: 61.04,
    height: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.285,
    y: 147.86,
    style: {
      fill: "#FF8578"
    },
    width: 73.789,
    height: 0.996
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.72,
    y: 119.066,
    style: {
      fill: "#F9FBFC"
    },
    width: 1.275,
    height: 1.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M232.995,165.846h-1.275v-2.6h1.275V165.846z M232.995,159.345h-1.275v-2.6h1.275V159.345z  M232.995,152.844h-1.275v-2.6h1.275V152.844z M232.995,146.344h-1.275v-2.6h1.275V146.344z M232.995,139.843h-1.275v-2.6 h1.275V139.843z M232.995,133.343h-1.275v-2.6h1.275V133.343z M232.995,126.842h-1.275v-2.6h1.275V126.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.72,
    y: 169.747,
    style: {
      fill: "#F9FBFC"
    },
    width: 1.275,
    height: 1.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D262D"
    },
    points: "325.176,270.292 256.507,270.292 256.507,266.393 322.865,266.393 354.807,208.023  358.228,209.895  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040566363977330435510000000614793347822110616_",
    cx: 191.8114,
    cy: 154.9692,
    r: 33.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBB9C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040566363977330435510000000614793347822110616_)"
    },
    d: "M215.243,146.34 c0,0-0.91,6.06-4.57,11.71c-3.66,5.65-11.91,13.95-14.19,14.66c-0.92,0.28-4.19-1.2-7.76-3.07c-1.17-0.61-2.37-1.27-3.54-1.91 c-4.11-2.28-7.73-4.48-7.73-4.48l-5.45-7.69c2.21-11.15,6.15-19.51,12.21-27.42c6.05-7.92,19.57-3.16,24.49,0.64 C213.633,132.58,216.313,138.54,215.243,146.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA78B"
    },
    d: "M184.934,147.267c-0.161,4.978,3.124,6.855,3.781,7.7c0.657,0.845-3.754,5.443-5.725,3.379 C181.019,156.281,184.934,147.267,184.934,147.267z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC8AF"
    },
    points: "308.285,397.921 310.722,409.64 294.636,412.409 290.931,398.994  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M341.56,415.055l1.046,5.865l-51.021,9.101l-1.036-5.809c0,0,45.227-8.589,50.151-9.036 L341.56,415.055z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100373383130247894230000009580437340798482321_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6765,
    y1: 402.4634,
    x2: 319.9373,
    y2: 427.1638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7978E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563FDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100373383130247894230000009580437340798482321_)"
    },
    d: "M319.882,408.145 c0.086-0.123,0.134-0.258,0.144-0.404c1.024,0.393,2.086,0.798,3.169,1.217l-3.608,4.999 c-0.29,0.394-0.19,0.952,0.203,1.242c0.206,0.143,0.448,0.19,0.675,0.15c0.209-0.037,0.421-0.165,0.549-0.35l3.74-5.167 c0.057-0.082,0.097-0.161,0.099-0.252c6.852,2.593,14.037,5.236,15.847,5.596c-4.924,0.446-50.151,9.036-50.151,9.036 l1.612-13.498c0.069-0.575,0.623-0.954,1.191-0.843c11.975,2.343,16.132-2.868,17.264-4.888 c0.24-0.428,0.753-0.605,1.21-0.428c0.528,0.204,1.282,0.496,2.204,0.854l-3.565,4.937c-0.29,0.394-0.193,0.934,0.2,1.224 c0.206,0.143,0.451,0.208,0.678,0.167c0.209-0.037,0.421-0.165,0.564-0.371l3.723-5.164 c0.029-0.041,0.057-0.082,0.065-0.138c0.831,0.32,1.758,0.676,2.745,1.058l-3.723,5.163c-0.29,0.394-0.211,0.938,0.2,1.224 c0.188,0.146,0.434,0.211,0.678,0.167c0.209-0.037,0.421-0.165,0.546-0.367L319.882,408.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M321.014,414.998c-0.129,0.185-0.34,0.313-0.549,0.35c-0.227,0.04-0.469-0.006-0.675-0.15 c-0.394-0.29-0.493-0.848-0.203-1.242l3.608-4.999c0.559,0.206,1.1,0.416,1.659,0.622c-0.002,0.09-0.042,0.169-0.099,0.252 L321.014,414.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M318.44,407.124c0.503,0.198,1.045,0.408,1.586,0.617c-0.01,0.146-0.058,0.28-0.144,0.404 l-3.74,5.167c-0.126,0.202-0.337,0.33-0.546,0.367c-0.244,0.044-0.49-0.021-0.678-0.167c-0.411-0.287-0.49-0.831-0.2-1.224 L318.44,407.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M311.908,411.367c-0.143,0.206-0.354,0.333-0.564,0.371 c-0.227,0.04-0.472-0.024-0.678-0.167c-0.394-0.29-0.49-0.83-0.2-1.224l3.565-4.937c0.503,0.198,1.065,0.422,1.665,0.657 c-0.008,0.055-0.037,0.097-0.065,0.138L311.908,411.367z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243C55"
    },
    d: "M220.932,322.521c-10.451,0.527-24.412,1.267-42.643,1.969 c-51.008,1.95-40.615-47.44-40.615-47.44l48.746-0.643c0,0,72.476-1.072,87.743,8.677 c15.267,9.749,37.535,112.623,37.535,112.623l-24.277,6.78c0,0-19.673-42.286-31.157-64.807 c-4.719-9.262-8.131-16.067-8.423-16.808C247.216,321.215,239.748,321.546,220.932,322.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A2033"
    },
    d: "M187.974,276.391c-1.001,0.008-1.554,0.016-1.554,0.016l-48.746,0.643 c0,0-5.827,27.703,12.674,40.794c18.414-4.454,29.387-23.14,39.052-39.905L187.974,276.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A2033"
    },
    d: "M256.263,339.68l-4.036,61.03l-4.387,0.098v-2.535h-17.393v2.964l-4.797,0.117l-4.719-78.832 c18.816-0.975,26.284-1.306,26.908,0.351C248.132,323.613,251.545,330.418,256.263,339.68z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC8AF"
    },
    points: "247.84,400.807 247.84,411.921 230.447,411.921 230.447,401.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0A2033"
    },
    points: "247.84,398.272 247.84,400.807 230.447,401.236 230.447,398.272  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M277.331,422.849v5.958h-51.827v-5.9c0,0,46.033-0.514,50.959-0.089L277.331,422.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143586123676473445240000003775960366657213614_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.8611,
    y1: 403.5972,
    x2: 257.3345,
    y2: 433.8619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7978E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563FDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143586123676473445240000003775960366657213614_)"
    },
    d: "M257.203,412.24 c0.106-0.106,0.177-0.23,0.213-0.372c0.939,0.567,1.914,1.152,2.906,1.754l-4.43,4.288 c-0.354,0.337-0.354,0.904-0.018,1.258c0.177,0.177,0.408,0.266,0.638,0.266c0.213,0,0.443-0.089,0.603-0.248l4.589-4.43 c0.071-0.071,0.124-0.142,0.142-0.23c6.29,3.756,12.899,7.619,14.618,8.292c-4.926-0.425-50.959,0.089-50.959,0.089 l3.957-13.005c0.168-0.554,0.781-0.83,1.321-0.621c11.377,4.41,16.384,0.01,17.854-1.78 c0.311-0.379,0.847-0.463,1.266-0.209c0.484,0.294,1.175,0.714,2.02,1.228l-4.377,4.235 c-0.354,0.337-0.354,0.886-0.018,1.24c0.177,0.177,0.408,0.284,0.638,0.284c0.213,0,0.443-0.089,0.62-0.266l4.571-4.43 c0.036-0.035,0.071-0.071,0.089-0.124c0.762,0.461,1.612,0.974,2.516,1.524l-4.571,4.43 c-0.354,0.337-0.372,0.886-0.018,1.24c0.16,0.177,0.39,0.283,0.638,0.283c0.213,0,0.443-0.089,0.602-0.266L257.203,412.24z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M257.115,419.186c-0.16,0.16-0.39,0.248-0.603,0.248c-0.23,0-0.461-0.089-0.638-0.266 c-0.337-0.354-0.337-0.921,0.018-1.258l4.43-4.288c0.514,0.301,1.01,0.603,1.524,0.904 c-0.018,0.089-0.071,0.159-0.142,0.23L257.115,419.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M255.963,410.982c0.461,0.284,0.957,0.585,1.453,0.886 c-0.035,0.142-0.106,0.266-0.213,0.372l-4.589,4.43c-0.159,0.177-0.39,0.266-0.602,0.266c-0.248,0-0.478-0.106-0.638-0.283 c-0.354-0.354-0.337-0.904,0.018-1.24L255.963,410.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M248.787,414.012c-0.177,0.177-0.408,0.266-0.62,0.266c-0.23,0-0.461-0.106-0.638-0.284 c-0.337-0.354-0.337-0.904,0.018-1.24l4.377-4.235c0.461,0.284,0.975,0.602,1.524,0.939 c-0.018,0.053-0.053,0.089-0.089,0.124L248.787,414.012z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA78B"
    },
    d: "M276.113,262.759h-28.76c0,0-43.384-7-51.827-12.187c-3.139-1.93-8.521-7.838-14.078-14.507 l19.596-16.32c3.432,5.44,6.551,9.866,7.799,10.354c3.412,1.287,35.741,19.323,39.484,19.323 C252.071,249.422,269.932,249.11,276.113,262.759z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120535411694705832200000015476850849662372999_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.047,
    y1: 214.6269,
    x2: 202.3707,
    y2: 214.6269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#606BF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120535411694705832200000015476850849662372999_)"
    },
    d: "M202.371,219.336l-20.923,16.73 c-9.476-11.368-19.401-24.977-19.401-24.977l29.67-17.899C191.717,193.189,199.333,211.292,202.371,219.336z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132767145251339376920000006211745070026727359_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.8005,
    y1: 188.6416,
    x2: 187.7856,
    y2: 290.8069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#606BF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132767145251339376920000006211745070026727359_)"
    },
    d: "M184.47,178.252l-21.448-8.443 c0,0-25.577,2.973-27.342,64.6c-0.341,11.895-0.224,77.648,3.401,79.336c14.452,6.728,51.668-37.371,51.668-37.371 c0.738-1.37-0.312-15.586,0-16.99c-0.897-0.332-1.638-0.683-2.223-1.014c-3.802-2.242-10.9-11.66-17.88-21.838l22.072-17.197 c0.877,1.384,1.755,2.73,2.593,4.036C195.896,190.497,184.47,178.252,184.47,178.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3030EF"
    },
    d: "M190.749,259.385c-0.897-0.332-1.638-0.683-2.223-1.014c-3.802-2.242-10.9-11.66-17.88-21.838 l10.833-8.441l-10.833-16.062l-19.522-12.764v8.794c0,0,8.359,22.74,18.307,40.572c5.402,9.683,14.342,14.435,21.389,16.76 C190.713,262.453,190.626,259.935,190.749,259.385z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000100356857888952308650000014380935086598478001_",
    cx: 226.2258,
    cy: 243.9706,
    r: 42.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBB9C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100356857888952308650000014380935086598478001_)"
    },
    d: "M253.688,255.936 c0,0-45.334-18.521-48.417-19.193c-0.974-0.21-4.307-4.813-8.414-11.024c-0.861-1.339-3.269-5.013-4.138-6.384l-22.072,17.198 c6.98,10.178,14.078,19.596,17.88,21.838c0.585,0.331,1.326,0.682,2.223,1.014c0.01-0.046,0.02-0.089,0.03-0.134 c-0.01,0.044-0.017,0.085-0.027,0.129c13.176,4.935,60.612,7.21,61.531,7.521c1.703,1.318,5.706,1.405,9.311,0.41 c1.666-0.46,3.257-1.144,4.475-2.064c3.17-2.374,7.904,0.977,10.044,2.591c1.391,1.05,4.624,1.013,5.693-0.056 C279.37,254.134,253.688,255.936,253.688,255.936z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000178200371858222591860000008059529359567381924_",
    cx: 191.8156,
    cy: 154.9702,
    r: 33.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBB9C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178200371858222591860000008059529359567381924_)"
    },
    points: "189.363,168.34  188.723,169.64 187.343,172.43 187.093,172.94 184.473,178.25 163.023,169.81 172.003,155.56 186.223,166.03  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105414378184013016790000017026940422298635691_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.8902,
    y1: 176.209,
    x2: 173.8902,
    y2: 242.416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#606BF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105414378184013016790000017026940422298635691_)"
    },
    d: "M151.124,208.06l22.36,34.356 l25.563-14.679c0,0-6.961-26.773-13.716-41.504c-4.198-9.154-16.277-13.693-27.966-6.413 C147.068,186.232,147.377,201.209,151.124,208.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098215872742362313310000007299559930853594801_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.5275,
    y1: 119.4558,
    x2: 200.5275,
    y2: 156.0838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56549E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9898,
    style: {
      stopColor: "#2E2C71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098215872742362313310000007299559930853594801_)"
    },
    d: "M193.29,146.239 c-0.82-3.729-4.232-7.161-7.306-2.173c-0.762,1.237-1.021,2.713-1.173,4.158c-0.546,5.196-6.594,7.482-11.114,7.826 c-0.715,0.055-1.465,0.05-2.175-0.078c0,0,1.143-8.554,3.677-18.858s8.282-20.81,16.576-16.595c0,0,7.638-3.564,12.284,2.349 c0,0,7.884-2.825,11.966,3.515c0,0,11.071,2.091,13.139,8.968c2.629,8.739-9.608,10.865-13.691,8.392 c-4.083-2.474-7.17-7.169-9.986-7.083c-2.816,0.085-2.18,4.408-2.603,7.083c-0.422,2.675-4.567-0.077-6.327,3.513 c-1.76,3.59-2.636,5.599-3.692,4.965C191.812,151.588,193.29,146.239,193.29,146.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA78B"
    },
    d: "M191.812,147.147c0.314-1.344-0.521-3.245-1.693-3.326c-1.498-0.104-2.191,1.731-2.298,3.338 c-0.099,1.478,0.342,4.038,1.976,3.482c1.251-0.426-0.143-1.932,0.306-2.753C190.596,146.986,191.81,148.59,191.812,147.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA78B"
    },
    d: "M188.723,169.64l-1.38,2.79c-4.51-3.22-4.33-8.1-4.33-8.1S184.316,167.109,188.723,169.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112B46"
    },
    d: "M107.669,219.399c0.001,0.174,0.007,0.239,0.011,0.301c0.016,0.205,0.026,0.258,0.039,0.372 c0.05,0.388,0.15,1.073,0.307,2.12c1.164,7.779,5.328,34.437,9.206,59.18c3.877,24.738,7.464,47.539,7.464,47.54l7.705-1.212 c-0.001-0.005-0.265-1.686-0.73-4.639c-1.625-10.335-5.687-36.188-9.343-59.563c-1.828-11.687-3.554-22.755-4.823-30.951 c-0.634-4.098-1.155-7.479-1.515-9.856c-0.18-1.188-0.321-2.126-0.415-2.771c-0.047-0.322-0.082-0.571-0.104-0.73l-0.02-0.152 l0-0.001l-2.305,0.252l2.311-0.194l-0.006-0.059l-2.305,0.252l2.311-0.194l-3.607,0.302h3.62 c-0.002-0.214-0.01-0.255-0.012-0.302l-3.607,0.302h3.62H107.669L107.669,219.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A2033"
    },
    d: "M176.577,339.44h9.445v90.658c0,0.898-0.728,1.626-1.626,1.626h-6.193 c-0.898,0-1.626-0.728-1.626-1.626V339.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A2033"
    },
    d: "M176.577,409.06h9.445v21.038c0,0.898-0.728,1.626-1.626,1.626h-6.193 c-0.898,0-1.626-0.728-1.626-1.626V409.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112B46"
    },
    d: "M155.328,340.735h51.943v1.541c0,3.502-2.839,6.34-6.34,6.34h-39.262 c-3.502,0-6.34-2.839-6.34-6.34V340.735z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145748046421640593930000016816606651254457013_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.2831,
    y1: 302.3041,
    x2: 198.3159,
    y2: 361.2508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC827D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5A7D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145748046421640593930000016816606651254457013_)"
    },
    d: "M131.153,340.977h100.293 c4.087,0,7.401-3.313,7.401-7.401v-3.598c0-4.087-3.313-7.401-7.401-7.401H131.153c-4.087,0-7.401,3.313-7.401,7.401v3.598 C123.752,337.664,127.066,340.977,131.153,340.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A2033"
    },
    d: "M132.287,426.196c0,3.053,2.475,5.528,5.528,5.528c3.053,0,5.528-2.475,5.528-5.528 c0-3.053-2.475-5.528-5.528-5.528C134.762,420.668,132.287,423.143,132.287,426.196z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0A2033"
    },
    cx: 224.784,
    cy: 426.196,
    r: 5.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.799,
    y: 402.022,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 362.599 820.6477)",
    style: {
      fill: "#112B46"
    },
    width: 19.001,
    height: 16.604
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052793378709556236420000006642410930676499111_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4956,
    y1: 396.821,
    x2: 194.3331,
    y2: 443.305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC827D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5A7D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052793378709556236420000006642410930676499111_)"
    },
    d: "M132.287,422.533h98.025v-2.062 c0-3.176-2.575-5.751-5.751-5.751h-86.522c-3.176,0-5.751,2.575-5.751,5.751V422.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166675611299972472990000009287532333123230088_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.1706,
    y1: 220.7478,
    x2: 126.6051,
    y2: 259.6053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC827D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5A7D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166675611299972472990000009287532333123230088_)"
    },
    d: "M105.345,225.827l4.161,30.848 c0.593,4.398,4.639,7.482,9.037,6.888c4.398-0.593,7.482-4.639,6.888-9.037l-4.161-30.848 c-0.593-4.398-4.639-7.482-9.037-6.888C107.836,217.383,104.752,221.429,105.345,225.827"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.571,
    y: 279.478,
    style: {
      fill: "#BC8867"
    },
    width: 8.449,
    height: 151.194
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.282,
    y: 279.478,
    style: {
      fill: "#BC8867"
    },
    width: 8.449,
    height: 151.194
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.946,
    y: 270.054,
    style: {
      fill: "#F9FBFC"
    },
    width: 150.543,
    height: 10.559
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.937,
    y: 64.572,
    style: {
      fill: "#FF8578"
    },
    width: 43.527,
    height: 26.83
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 208.2762 82.9451)",
    style: {
      fill: "#F9FBFC",
      fontFamily: "'FiraSans-Medium'",
      fontSize: "16.1353px"
    }
  }, "&lt;/&gt;")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.035,
    y: 96.405,
    style: {
      fill: "#FBD15B"
    },
    width: 49.111,
    height: 32.848
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9FBFC"
    },
    d: "M136.289,105.834c-2.346,2.935-2.309,7.222,0.08,10.122c2.715,3.294,7.365,3.824,10.705,1.596 l5.154,5.155c0.217,0.217,0.57,0.217,0.788,0l1.448-1.448c0.217-0.217,0.217-0.57,0-0.788l-5.155-5.155 c2.088-3.13,1.753-7.41-1.007-10.17C144.946,101.788,139.339,102.017,136.289,105.834z M146.634,114.876 c-2.222,2.222-5.838,2.222-8.061,0c-2.222-2.222-2.222-5.838,0-8.06c2.222-2.222,5.838-2.222,8.06,0 C148.856,109.037,148.857,112.653,146.634,114.876z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.25,
    y: 88.674,
    style: {
      fill: "#878CF0"
    },
    width: 37.695,
    height: 26.854
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 367.4749 108.8297)",
    style: {
      fill: "#F1F2F2",
      fontFamily: "'FiraSans-Medium'",
      fontSize: "19.2481px"
    }
  }, "{ }"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero3);
export default __webpack_public_path__ + "static/media/hero-3.164e57c2008ce7de42d5c2e0b32f0ce0.svg";
export { ForwardRef as ReactComponent };